import { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

const OverlayWrapper = ({ isDark, onClose, icon: Icon, iconColor, title, subtitle, large, widthClass, children }) => {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return createPortal(
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" onClick={onClose}>
      <div className={`absolute inset-0 ${isDark ? "bg-black/70" : "bg-black/40"} backdrop-blur-sm`} />
      <div
        className={`relative w-full ${widthClass || (large ? "max-w-5xl" : "max-w-4xl")} rounded-2xl overflow-hidden ${
          isDark ? "bg-[#0b0b0d] border border-white/10" : "bg-white border border-black/10 shadow-2xl"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={`flex items-center justify-between px-6 py-4 border-b ${isDark ? "border-white/10" : "border-black/10"}`}>
          <div className="flex items-center gap-3">
            {Icon && (
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${isDark ? "bg-white/[0.06]" : "bg-black/[0.04]"}`}>
                <Icon className="w-5 h-5" style={{ color: iconColor || (isDark ? "#94a3b8" : "#64748b") }} />
              </div>
            )}
            <div>
              <h3 className={`text-lg font-bold ${isDark ? "text-white" : "text-[#1d1d1f]"}`}>{title}</h3>
              {subtitle && <p className={`text-sm ${isDark ? "text-white/55" : "text-black/55"}`}>{subtitle}</p>}
            </div>
          </div>
          <button
            onClick={onClose}
            data-testid="overlay-close-btn"
            className={`p-2 rounded-lg ${isDark ? "hover:bg-white/10 text-white/60" : "hover:bg-black/[0.05] text-black/55"}`}
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        {children}
      </div>
    </div>,
    document.body
  );
};

export default OverlayWrapper;
